export default __webpack_public_path__ + "static/media/NG.bca0a662.svg";